<template>
  <el-table-column
    :label="generateLabel(metricGroup.name)"
    :align="columnAlign"
  >
    <rest-metric-column
      v-for="(metric, index) in metricGroup.metrics"
      :key="index"
      :prop="prop"
      :index="index"
      :metric-group="metricGroup"
      :metric="metric"
      :custom-props="customProps"
      :width="width"
      :sortable="sortable"
    />
  </el-table-column>
</template>

<script>
import RestMetricColumn from '@/common/components/rest/RestMetricColumn'
import { restMetricGroupLabels } from '@/common/enum/RestMetricGroupEnum'

export default {
  name: 'RestMetricGroup',

  components: { RestMetricColumn },

  props: {
    metricGroup: {
      type: Object,
      required: true
    },

    prop: {
      type: String,
      required: true
    },

    align: {
      type: String
    },

    width: {
      type: Number
    },

    customProps: {
      type: Object,
      default: () => ({})
    },

    sortable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      restMetricGroupLabels
    }
  },

  computed: {
    columnAlign() {
      return this.align ? this.align : 'center'
    }
  },

  methods: {
    generateLabel(metricName) {
      return this.restMetricGroupLabels[metricName]
        ? this.$t(this.restMetricGroupLabels[metricName])
        : metricName
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestMetricGroup.vue